import { alertTypes } from "./notifications.js";
import { humanTime } from "./menu-operationplans.js";

const { redom } = window;
const { el, list, place } = redom;

export default class Notifications {
  constructor({ app, api, i18n }) {
    this.app = app;
    this.api = api;
    this.i18n = i18n;
    this.el = el(
      ".notifications",
      (this.notificationsText = el("h2")),
      el(
        ".menu-content",
        (this.noNotifications = place((this.noNotificationsText = el("p")))),
        (this.notifications = list(".notifications", Notification, "_id", {
          app,
          api,
        }))
      )
    );
  }

  update(data) {
    const { i18n } = this;
    const { allNotifications } = data;

    this.notificationsText.textContent = i18n("notifications");
    this.noNotificationsText.textContent = i18n("notifications.empty");

    this.noNotifications.update(!allNotifications.length);
    this.notifications.update(allNotifications);
  }
}

class Notification {
  constructor({ api, app }) {
    this.api = api;
    this.app = app;
    this.el = el(
      ".notification",
      (this.title = el(".notification-title")),
      (this.text = el(".notification-text")),
      (this.date = el(".notification-date"))
    );
  }

  update(data) {
    const { type, createdAt, operationPlanIds } = data;

    const operationPlans = [];

    for (const operationPlanId of operationPlanIds || []) {
      const operationPlan = this.api.operationplansLookup[operationPlanId];

      if (operationPlan) {
        operationPlans.push(operationPlan);
      }
    }

    let severity = data.severity === "AUTO_ACKNOWLEDGE" ? "" : data.severity;
    let text = type === "OTHER_SEE_FREE_TEXT" ? "" : data.text;
    const humanType =
      type === "OPERATION_PLAN_STATE_CHANGED"
        ? ""
        : type === "OTHER_SEE_FREE_TEXT"
        ? data.text
        : alertTypes[type];

    if (operationPlans.length) {
      if (text) {
        text += "<br>";
      }
      text += `(${operationPlans
        .map((operationPlan) => operationPlan.publicInfo.title)
        .join(", ")})`;
    }

    this.title.textContent = severity + (humanType ? `: ${humanType}` : "");
    this.text.innerHTML = text;
    this.date.textContent = humanTime(new Date(createdAt));
  }
}
